/* TIMELESS — clean theme v2: shared UI + cart logic */
(function () {
  'use strict';
  var CFG = window.TL_CFG || {};
  var MM = (CFG.mmHandles || []).map(function (h) { return String(h).trim(); }).filter(Boolean);
  var OFF = CFG.mmOff || { 2: 2599, 3: 5398, 4: 8097 };
  var GIFT = String(CFG.giftVariant || ''), GIFT_MIN = Number(CFG.giftMin || 10000);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function fmt(cents, format) {
    format = format || CFG.moneyFormat || '€{{amount_with_comma_separator}}';
    cents = Math.round(Number(cents) || 0);
    function delim(num, precision, thousands, decimal) {
      var n = (num / 100).toFixed(precision).split('.');
      var d = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return d + (n[1] ? decimal + n[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return delim(cents, 2, ',', '.');
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return delim(cents, 2, '.', ',');
      }
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) {
    if (!url) return '';
    if (url.indexOf('?') > -1) return url + '&width=' + w;
    return url + '?width=' + w;
  }
  function isMM(handle) { return MM.indexOf(handle) > -1; }
  function bundlePrice(unitCents, n) {
    var tier = Math.min(n, 4);
    var off = tier >= 2 ? (OFF[tier] || 0) : 0;
    return unitCents * n - off;
  }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    var t = $('#tToast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-shown');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-shown'); }, 2600);
  }

  /* ---------- body lock ---------- */
  var locks = 0;
  function lock() { locks++; document.body.classList.add('t-lock'); }
  function unlock() { locks = Math.max(0, locks - 1); if (!locks) document.body.classList.remove('t-lock'); }

  /* ---------- cart API ---------- */
  function j(r) {
    return r.json().then(function (d) {
      if (!r.ok) { var e = new Error(d.description || d.message || 'Error'); e.data = d; throw e; }
      return d;
    });
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(j); }
  function add(items, opts) {
    opts = opts || {};
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(j).then(function () {
      return getCart();
    }).then(function (cart) {
      renderCart(cart);
      bump();
      if (opts.open !== false) openCart();
      return cart;
    }).catch(function (e) {
      toast((e && e.message) || 'Could not add to cart');
      throw e;
    });
  }
  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(j).then(function (cart) { renderCart(cart); return cart; })
      .catch(function (e) { toast((e && e.message) || 'Could not update cart'); });
  }
  function bump() {
    $$('.t-cart-btn').forEach(function (b) { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); });
  }

  /* ---------- drawer ---------- */
  var drawer, lastCart = null;
  function openCart() {
    drawer = drawer || $('#tDrawer'); if (!drawer) { location.href = '/cart'; return; }
    if (!drawer.classList.contains('is-open')) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); lock(); }
    if (!lastCart) getCart().then(renderCart);
  }
  function closeCart() {
    drawer = drawer || $('#tDrawer'); if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); unlock();
  }
  function insuranceId() { var el = $('[data-insurance-variant]'); return el ? String(el.getAttribute('data-insurance-variant')) : null; }

  function renderCart(cart) {
    lastCart = cart;
    var insId = insuranceId();
    var lines = cart.items.filter(function (i) { return String(i.variant_id) !== insId && String(i.variant_id) !== GIFT; });
    var giftLine = cart.items.filter(function (i) { return GIFT && String(i.variant_id) === GIFT; })[0];
    var insLine = cart.items.filter(function (i) { return String(i.variant_id) === insId; })[0];
    var spend = cart.total_price - (insLine ? insLine.final_line_price : 0) - (giftLine ? giftLine.final_line_price : 0);
    var count = lines.reduce(function (a, i) { return a + i.quantity; }, 0);
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.setAttribute('data-count', count); });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = '(' + count + ')'; });

    var linesEl = $('#tDrawerLines'); if (!linesEl) return;
    var empty = $('#tDrawerEmpty'), foot = $('#tDrawerFoot'), prog = $('#tDrawerProgress');
    empty.hidden = count > 0; foot.hidden = count === 0;

    linesEl.innerHTML = lines.map(function (i) {
      var variant = (i.variant_title && i.variant_title !== 'Default Title') ? '<div class="t-line-var">Size ' + esc(i.variant_title) + '</div>' : '';
      var was = i.original_line_price > i.final_line_price ? '<s>' + fmt(i.original_line_price) + '</s>' : '';
      return '<div class="t-line" data-key="' + esc(i.key) + '" data-qty="' + i.quantity + '">' +
        '<a class="t-line-img" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(img(i.image, 240)) + '" alt="' + esc(i.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div><a class="t-line-title" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + variant +
        '<div class="t-qty"><button type="button" data-qty-step="-1" aria-label="Decrease">−</button><span>' + i.quantity + '</span><button type="button" data-qty-step="1" aria-label="Increase">+</button></div></div>' +
        '<div class="t-line-right"><div class="t-line-price">' + was + fmt(i.final_line_price) + '</div><button type="button" class="t-line-remove" data-remove>Remove</button></div>' +
        '</div>';
    }).join('') + (giftLine ? '<div class="t-line t-line--gift"><span class="t-line-img">' + (giftLine.image ? '<img src="' + esc(img(giftLine.image, 240)) + '" alt="">' : '<span style="display:flex;height:100%;align-items:center;justify-content:center;font-size:22px">?</span>') + '</span><div><span class="t-line-title">Mystery Gift</span><div class="t-line-var">A free surprise with your order</div></div><div class="t-line-right"><div class="t-line-price t-line-free">Free</div></div></div>' : '');

    // insurance checkbox
    var insBox = $('#tInsure');
    if (insBox && insId) insBox.checked = cart.items.some(function (i) { return String(i.variant_id) === insId; });

    // totals
    var disc = cart.original_total_price - cart.total_price;
    $('#tSubtotal').textContent = fmt(cart.original_total_price);
    var discRow = $('#tDiscRow');
    discRow.hidden = disc <= 0;
    if (disc > 0) {
      $('#tDisc').textContent = '−' + fmt(disc);
      var titles = [];
      (cart.cart_level_discount_applications || []).forEach(function (d) { titles.push(d.title); });
      cart.items.forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (a) { if (a.discount_application && titles.indexOf(a.discount_application.title) < 0) titles.push(a.discount_application.title); }); });
      $('#tDiscLabel').textContent = titles.length ? titles.join(' + ') : 'Discount';
    }
    $('#tTotal').textContent = fmt(cart.total_price);

    // Mix & Match progress
    var mmCount = lines.reduce(function (a, i) { return a + (isMM(i.handle) ? i.quantity : 0); }, 0);
    var mmUnit = 0; lines.forEach(function (i) { if (isMM(i.handle) && !mmUnit) mmUnit = i.original_price; });
    var giftMsg = '';
    if (GIFT && count > 0) {
      giftMsg = spend >= GIFT_MIN ? '<div style="margin-top:8px"><b>Mystery gift unlocked.</b> It\'s in your cart for free.</div>'
        : '<div style="margin-top:8px">Spend <b>' + fmt(GIFT_MIN - spend) + '</b> more for a <b>free mystery gift</b>.</div>';
    }
    if (mmCount > 0 && prog) {
      prog.hidden = false;
      var meter = '<div class="t-meter">' + [1, 2, 3, 4].map(function (n) { return '<i class="' + (mmCount >= n ? 'on' : '') + '"></i>'; }).join('') + '</div>';
      var msg;
      if (mmCount >= 4) msg = '<b>Best deal unlocked.</b> Your longsleeves are at the lowest bundle price.';
      else {
        var next = mmCount + 1;
        msg = 'Add <b>1 more longsleeve</b> — ' + next + ' for <b>' + fmt(bundlePrice(mmUnit, next)) + '</b>';
        if (mmCount >= 2) msg = '<b>Mix &amp; Match applied.</b> ' + msg;
      }
      prog.innerHTML = msg + meter + giftMsg;
    } else if (prog && giftMsg) { prog.hidden = false; prog.innerHTML = giftMsg.replace('margin-top:8px', 'margin-top:0'); }
    else if (prog) prog.hidden = true;

    renderUpsell(lines, mmCount);
    syncGift(cart, spend, giftLine, count);
  }

  var giftBusy = false;
  function syncGift(cart, spend, giftLine, count) {
    if (!GIFT || giftBusy) return;
    var want = count > 0 && spend >= GIFT_MIN;
    if (want && !giftLine) {
      giftBusy = true;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(GIFT), quantity: 1 }] }) })
        .then(j).then(getCart).then(function (c) { giftBusy = false; renderCart(c); }).catch(function () { giftBusy = false; });
    } else if (giftLine && (!want || giftLine.quantity > 1)) {
      giftBusy = true;
      change(giftLine.key, want ? 1 : 0).then(function () { giftBusy = false; }, function () { giftBusy = false; });
    }
  }

  var lsCache = null;
  function loadLongsleeves() {
    if (lsCache) return Promise.resolve(lsCache);
    return Promise.all(MM.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      lsCache = list.filter(function (p) { return p && p.available && p.price > 0; });
      return lsCache;
    });
  }
  function renderUpsell(lines, mmCount) {
    var box = $('#tDrawerUpsell'), row = $('#tDrawerUpsellRow');
    if (!box) return;
    if (mmCount < 1 || mmCount >= 4) { box.hidden = true; return; }
    loadLongsleeves().then(function (list) {
      var inCart = lines.map(function (i) { return i.handle; });
      var picks = list.filter(function (p) { return inCart.indexOf(p.handle) < 0; });
      if (!picks.length) picks = list;
      if (!picks.length) { box.hidden = true; return; }
      row.innerHTML = picks.slice(0, 6).map(function (p) {
        return '<div class="t-upsell-item"><a class="t-line-img" href="/products/' + esc(p.handle) + '"><img src="' + esc(img(p.featured_image, 240)) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
          '<div>' + esc(p.title) + '</div><button type="button" data-quick-add="' + esc(p.handle) + '">+ Add</button></div>';
      }).join('');
      box.hidden = false;
    });
  }

  /* ---------- quick add sheet ---------- */
  var qa, qaVariant = null, qaProduct = null;
  function openQA(handle) {
    qa = qa || $('#tQA'); if (!qa) { location.href = '/products/' + handle; return; }
    fetch('/products/' + handle + '.js').then(j).then(function (p) {
      qaProduct = p; qaVariant = null;
      $('#tQAImg').src = img(p.featured_image, 240);
      $('#tQAImg').alt = p.title;
      $('#tQATitle').textContent = p.title;
      $('#tQAPrice').innerHTML = fmt(p.price) + (p.compare_at_price > p.price ? ' <s style="color:#767676">' + fmt(p.compare_at_price) + '</s>' : '');
      var sizes = $('#tQASizes');
      var single = p.variants.length === 1 && p.variants[0].title === 'Default Title';
      sizes.innerHTML = single ? '' : p.variants.map(function (v) {
        return '<button type="button" class="t-size" data-v="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
      }).join('');
      var addBtn = $('#tQAAdd');
      if (single) { qaVariant = p.variants[0].id; addBtn.disabled = !p.variants[0].available; addBtn.textContent = 'Add to cart — ' + fmt(p.price); }
      else { addBtn.disabled = true; addBtn.textContent = 'Choose a size'; }
      var note = $('#tQANote');
      note.textContent = isMM(p.handle) ? 'Mix & Match: 2 for ' + fmt(bundlePrice(p.price, 2)) + ' · 4 for ' + fmt(bundlePrice(p.price, 4)) : '';
      qa.classList.add('is-open'); qa.setAttribute('aria-hidden', 'false'); lock();
    }).catch(function () { location.href = '/products/' + handle; });
  }
  function closeQA() {
    qa = qa || $('#tQA'); if (!qa || !qa.classList.contains('is-open')) return;
    qa.classList.remove('is-open'); qa.setAttribute('aria-hidden', 'true'); unlock();
  }

  /* ---------- menu ---------- */
  function openMenu() { var m = $('#tMenu'); if (!m) return; m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); lock(); }
  function closeMenu() { var m = $('#tMenu'); if (!m || !m.classList.contains('is-open')) return; m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); unlock(); }

  /* ---------- global clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-cart-open]'))) { if (drawer || $('#tDrawer')) { e.preventDefault(); openCart(); } return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }
    if (t.closest('[data-menu-open]')) { openMenu(); return; }
    if (t.closest('[data-menu-close]')) { closeMenu(); return; }
    if (t.closest('[data-qa-close]')) { closeQA(); return; }
    if ((el = t.closest('[data-quick-add]'))) { e.preventDefault(); closeCart(); openQA(el.getAttribute('data-quick-add')); return; }
    if ((el = t.closest('[data-add-variant]'))) {
      e.preventDefault();
      if (el.disabled) return;
      el.classList.add('is-busy');
      add([{ id: Number(el.getAttribute('data-add-variant')), quantity: 1 }]).finally(function () { el.classList.remove('is-busy'); });
      return;
    }
    if ((el = t.closest('#tQASizes .t-size'))) {
      $$('#tQASizes .t-size').forEach(function (b) { b.classList.remove('is-active'); });
      el.classList.add('is-active');
      qaVariant = Number(el.getAttribute('data-v'));
      var b = $('#tQAAdd'); b.disabled = false; b.textContent = 'Add to cart — ' + fmt(qaProduct.price);
      return;
    }
    if (t.closest('#tQAAdd')) {
      if (!qaVariant) return;
      var btn = $('#tQAAdd'); btn.disabled = true; btn.textContent = 'Adding…';
      add([{ id: qaVariant, quantity: 1 }]).then(function () { closeQA(); }).catch(function () {}).finally(function () { btn.disabled = false; btn.textContent = 'Add to cart'; });
      return;
    }
    var line = t.closest('.t-line');
    if (line) {
      var key = line.getAttribute('data-key'), q = Number(line.getAttribute('data-qty'));
      if ((el = t.closest('[data-qty-step]'))) { change(key, Math.max(0, q + Number(el.getAttribute('data-qty-step')))); return; }
      if (t.closest('[data-remove]')) { change(key, 0); return; }
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'tInsure') {
      var id = insuranceId(); if (!id) return;
      var box = e.target; box.disabled = true;
      var p;
      if (box.checked) p = add([{ id: Number(id), quantity: 1 }], { open: false });
      else {
        var ln = (lastCart ? lastCart.items : []).filter(function (i) { return String(i.variant_id) === id; })[0];
        p = ln ? change(ln.key, 0) : Promise.resolve();
      }
      Promise.resolve(p).catch(function () {}).finally(function () { box.disabled = false; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeQA(); closeCart(); closeMenu(); } });

  /* ---------- header / announce / reveal ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var header = $('#tHeader');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
      onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    }
    var track = $('#tAnnounce');
    if (track && track.children.length > 1) {
      var idx = 0;
      setInterval(function () {
        if (window.innerWidth >= 990) return;
        idx = (idx + 1) % track.children.length;
        track.style.transform = 'translateY(' + (-34 * idx) + 'px)';
      }, 3800);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });
      $$('.t-reveal').forEach(function (el) { io.observe(el); });
    } else { $$('.t-reveal').forEach(function (el) { el.classList.add('is-in'); }); }
    getCart().then(renderCart).catch(function () {});
    var timers = $$('[data-ends]');
    if (timers.length) {
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        timers.forEach(function (el) {
          var end = new Date(el.getAttribute('data-ends')).getTime();
          var left = end - Date.now();
          if (!end || isNaN(end) || left <= 0) { el.hidden = true; return; }
          var d = Math.floor(left / 86400000), h = Math.floor(left % 86400000 / 3600000), m = Math.floor(left % 3600000 / 60000), sec = Math.floor(left % 60000 / 1000);
          el.querySelector('[data-timer-out]').textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
          el.hidden = false;
        });
      };
      tick(); setInterval(tick, 1000);
    }
  });

  window.TL = { add: add, openCart: openCart, closeCart: closeCart, fmt: fmt, esc: esc, img: img, isMM: isMM, bundlePrice: bundlePrice, toast: toast, getCart: getCart, off: OFF };
})();
